export enum ViewMode {
  Card = 'card',
  List = 'list',
  Table = 'table',
}
